import React from "react";
import { Button } from "@mui/material";

type Props = {
    handleFile?: (arg0: any) => void;
    disabled?: boolean;
    accept: string;
    name?: string;
    value: any;
    hideActions?: boolean;
};

const FileUploadButton = (props: Props) => {
    const hiddenFileInput = React.useRef(null);

    const handleClick = () => {
        // @ts-ignore
        hiddenFileInput.current.click();
    };

    const handleChange = (event: any) => {
        const fileUploaded = event.target.files[0];
        // @ts-ignore
        fileUploaded && props.handleFile(fileUploaded);
    };

    const onDeleteFile = () => {
        // @ts-ignore
        hiddenFileInput.current.value = null;
        // @ts-ignore
        props.handleFile(null);
    };
    return (
        <>
            {!props.hideActions &&
                (props.value ? (
                    <Button
                        onClick={onDeleteFile}
                        sx={{
                            color: "#d32f2f",
                        }}
                        disabled={props?.disabled}
                    >
                        Удалить
                    </Button>
                ) : (
                    <Button
                        onClick={handleClick}
                        sx={{
                            color: "black",
                        }}
                        disabled={props?.disabled}
                    >
                        Загрузить
                    </Button>
                ))}
            <input
                type="file"
                ref={hiddenFileInput}
                onChange={handleChange}
                style={{ display: "none" }}
                accept={props.accept}
                name={props.name}
            />
        </>
    );
};

export default FileUploadButton;
